<div class="container my-5 px-0 min-h-[50vh] pb-24 lg:pb-0">
  <ng-container *ngIf="modalData; else noData">


    <div class="w-full mt-10 p-3  flex justify-between items-center">
      <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
          <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
            *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
            <ng-container *ngIf="!last">
              <a [href]="first ? '/' : bread.url">
                {{ bread.name }}
              </a>
            </ng-container>
            <ng-container *ngIf="last">
              <span class=""> {{ bread.name }} </span>
            </ng-container>

          </li>
        </ol>
      </nav>
      <a mat-button color="primary" [href]="modalData?.hotelUrl"
        class="review-booking-link !bg-blue-500 !text-white !font-bold flex items-center">

        رزرو {{modalData?.hotelType + ' ' + modalData?.hotelName + ' ' + modalData?.cityTitle }}
      </a>
    </div>

    <div class="w-full mt-10 shadow-md rounded-md p-3 hidden lg:block">
      <h1 class="font-bold text-4xl">نظرات {{modalData?.hotelType + ' ' + modalData?.hotelName}} {{modalData?.cityTitle}}</h1>
      <address class="flex items-center mt-3">
        <i class="ico-Location-line text-xl ml-2"></i>
        <p class="text-sm">{{modalData?.hotelAddress}}</p>
      </address>
      <div class="p-3 mt-3 bg-[#f7f8f9] rounded-md flex items-center justify-between">

        <div class="flex items-center gap-2  w-full">
          <img src="assets/images/verified-comments.webp" class="mx-2">
          <div>
            <p class="text-sm">
              %100 نظرات تایید شده
            </p>
            <p class="text-sm text-gray-500">
              میهمانان واقعی ، اقامت های واقعی ، نظرات واقعی

            </p>
          </div>

        </div>
        <a href="/persian/pursuit/tracking/" mat-button color="primary"
          class="ml-auto !bg-blue-500 !text-white !font-bold flex items-center">
          ثبت نظر
        </a>
      </div>
    </div>

    <!-- Header: mobile -->
    <div class="w-full mt-4 px-3 lg:hidden space-y-4">
      <h1 class="font-bold text-xl leading-8 m-0">نظرات {{modalData?.hotelType + ' ' + modalData?.hotelName}} {{modalData?.cityTitle}}</h1>
      <address class="flex items-center gap-2 not-italic">
        <i class="ico-Location-line text-xl"></i>
        <p class="text-sm m-0">{{modalData?.hotelAddress}}</p>
      </address>
      <div class="flex items-start gap-2">
        <img src="assets/images/verified-comments.webp" class="w-8 h-8 mt-0.5" alt="">
        <div>
          <p class="text-sm font-medium m-0">۱۰۰٪ نظرات تایید شده</p>
          <p class="text-xs text-gray-500 mt-1 m-0">میهمانان واقعی ، اقامت های واقعی ، نظرات واقعی</p>
        </div>
      </div>
      <a href="/persian/pursuit/tracking/" mat-button color="primary"
        class="!w-full !h-11 !bg-blue-500 !text-white !font-bold !rounded-lg flex items-center justify-center">
        + ثبت نظر
      </a>
    </div>

    <div class="w-full flex-wrap lg:border-bottom mt-5 shadow-md rounded-md hidden lg:flex">
      <div class="flex items-center mt-3 lg:w-[30%] w-full mb-3 pr-5">
        <div class="w-[50%] flex flex-col">
          <div class="flex items-center">
            <h3 class="text-[54px] text-blue-500 ml-2">{{modalData?.labelHotelReview.avgRate}}</h3>
            <span class="text-[32px] text-muted mb-1">/</span>
            <span class="text-[32px] text-muted mb-1">5</span>
          </div>
          <div class="mr-3">
            <p class="text-blue-500"> {{modalData?.labelHotelReview.avgRateTitle}}</p>
            <i class="ico_check_fill svg-icon--22px text-green2"></i>
            <p class="text-[20px] text-muted">از {{modalData?.labelHotelReview.totalReview}} نظر</p>
          </div>
        </div>


      </div>
      <div
        class="lg:w-[70%] flex justify-between px-10 items-center  w-full lg:overflow-visible overflow-x-scroll x-scroll">

        <div class="  flex flex-col justify-center items-center">
          <p class=" text-blue-500 font-bold" style="font-size: 1.8rem;">
            {{modalData?.labelHotelReview.valueForMoneyReview}}</p>
          <p style="color: #767b93 !important;" *ngIf="accommodation() != 'ecolodge'">ارزش هتل نسبت به قیمت</p>
          <p style="color: #767b93 !important;" *ngIf="accommodation() == 'ecolodge'">ارزش اقامتگاه نسبت به قیمت</p>
        </div>
        <div class="flex flex-col justify-center items-center pr-10"
          [class.border-r]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-solid]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-gray-200]="modalData?.labelHotelReview.foodReview != 0" style="height: 100%;"
          [style.border-right-width]="modalData?.labelHotelReview.foodReview != 0 ? '1px' : '0'">
          <p class=" text-blue-500 font-bold" style="font-size: 1.8rem;">{{modalData?.labelHotelReview.comfortReview}}
          </p>
          <p style="color: #767b93 !important;">آرامش و راحتی</p>
        </div>
        <div class="flex flex-col justify-center items-center pr-10"
          [class.border-r]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-solid]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-gray-200]="modalData?.labelHotelReview.foodReview != 0" style="height: 100%;"
          [style.border-right-width]="modalData?.labelHotelReview.foodReview != 0 ? '1px' : '0'">
          <p class=" text-blue-500 font-bold" style="font-size: 1.8rem;">{{modalData?.labelHotelReview.staffReview}}</p>
          <p style="color: #767b93 !important;">عملکرد کارکنان</p>
        </div>
        <div *ngIf="modalData?.labelHotelReview.foodReview != 0" class="flex flex-col justify-center items-center pr-10"
          [class.border-r]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-solid]="modalData?.labelHotelReview.foodReview != 0"
          [class.border-gray-200]="modalData?.labelHotelReview.foodReview != 0" style="height: 100%;"
          [style.border-right-width]="modalData?.labelHotelReview.foodReview != 0 ? '1px' : '0'">
          <p class=" text-blue-500 font-bold" style="font-size: 1.8rem;">{{modalData?.labelHotelReview.foodReview}}</p>
          <p style="color: #767b93 !important;">کیفیت غذا</p>
        </div>
      </div>

      <div class="w-full bg-gray-200 my-5" style="height: 1px;"></div>

      <div class="w-[25%] mt-5 px-3 custom-progressbar-wrapper">
        <iho-progressbar [title]="accommodation() != 'ecolodge' ? 'امکانات هتل' : 'امکانات اقامتگاه'"
          [score]="modalData?.labelHotelReview.facilitiesReview" [hasAnimation]="true"
          [progressValue]="modalData?.labelHotelReview.facilitiesReview" [min]="0" [max]="5" />
        <iho-progressbar [title]="' موقعیت مکانی'" [score]="modalData?.labelHotelReview.locationReview"
          [hasAnimation]="true" [progressValue]="modalData?.labelHotelReview.locationReview" [min]="0" [max]="5" />
        <iho-progressbar
          [title]="accommodation() != 'ecolodge' ? ' پاکیزگی هتل و اتاق ها' : ' پاکیزگی اقامتگاه  و اتاق ها'"
          [score]="modalData?.labelHotelReview.cleanlinessReview" [hasAnimation]="true"
          [progressValue]="modalData?.labelHotelReview.cleanlinessReview" [min]="0" [max]="5" />
      </div>
      <div class="w-[25%] mt-5 px-3 custom-progressbar-wrapper">
        <iho-progressbar [title]="accommodation() != 'ecolodge' ? 'برای کسب و کارها' : 'برای کسب و کارها'"
          [score]="modalData?.labelHotelReview.businessReview" [hasAnimation]="true"
          [progressValue]="modalData?.labelHotelReview.businessReview" [min]="0" [max]="5" />
        <iho-progressbar [title]="'برای دوستان'" [score]="modalData?.labelHotelReview.friendsReview"
          [hasAnimation]="true" [progressValue]="modalData?.labelHotelReview.friendsReview" [min]="0" [max]="5" />
        <iho-progressbar [title]="accommodation() != 'ecolodge' ? 'برای خانواده ها' : 'برای خانواده ها'"
          [score]="modalData?.labelHotelReview.couplesReview" [hasAnimation]="true"
          [progressValue]="modalData?.labelHotelReview.couplesReview" [min]="0" [max]="5" />
      </div>
      <div class="w-[50%] flex justify-around px-5 mt-5 border-r border-solid">
        <div class="lg:block hidden">
          <h4 class="mb-3">امتیاز میهمانان</h4>
          <ul class="flex flex-col gap-2">
            <li *ngFor="let item of guestScore;let index = index" class="flex items-center">
              <input type="checkbox" [id]="'score-' + item.id" [(ngModel)]="item.selected"
                (change)="selectedScore(item.id,'desk')" class="w-4 h-4 cursor-pointer custom-checkbox">
              <label [for]="'score-' + item.id" class="text-sm mr-2 cursor-pointer">
                {{item.title}}
              </label>
            </li>
          </ul>
        </div>
        <div class="lg:block hidden">
          <h4 class="mb-3"> تاریخ نظرات</h4>
          <ul class="flex flex-col gap-2">
            <li *ngFor="let item of historyComments;let index = index" class="flex items-center">
              <input type="checkbox" [id]="'history-' + item.id" [(ngModel)]="item.selected"
                (change)="selectedHistoryComments(item.id,'desk')" class="w-4 h-4 cursor-pointer custom-checkbox">
              <label [for]="'history-' + item.id" class="text-sm mr-2 cursor-pointer">
                {{item.title}}
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div class="bg-[#fafafc] p-3 gap-5 mt-5 flex w-full justify-end items-center">

        <h3 class="whitespace-nowrap">فیلتر نظرات : </h3>

        <div class="w-full flex flex-wrap lg:flex-nowrap">
          <mat-form-field class="lg:ml-2 w-full lg:w-auto mb-3 lg:mb-0">
            <mat-label class="!text-sm">نوع سفر </mat-label>
            <mat-select [(ngModel)]="selectedType" (ngModelChange)="selectedTypes($event)">

              <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.travelTypes" [value]="item.id">
                {{item.name}}
              </mat-option>

            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-full lg:w-auto mx-2">
            <mat-label class="!text-sm">مرتب سازی</mat-label>
            <mat-select [(ngModel)]="selectedOrder" (ngModelChange)="selectedTypes($event)">

              <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.sortTypes" [value]="item.id">
                {{item.name}}
              </mat-option>

            </mat-select>
          </mat-form-field>
        </div>
        <button *ngIf="showRemoveBtn" (click)="removeFilters()" class="!border antialiased  w-[130px]
                        !border-solid
                        !border-blue-500" mat-button color="primary">
          حذف فیلترها
        </button>
      </div>
      <div class="bg-[#fafafc] p-3 w-full">
        <ul class="flex flex-wrap mt-3">
          <li
            class="border border-solid rounded-3xl p-2 mb-2 ml-2 cursor-pointer {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
            (click)="selectedLabels(item.name,'desk')"
            *ngFor="let item of listRoomsFilters?.voteFilterLabels;let index = index">
            <span class="text-sm"> {{item.name}} ({{item.count}})</span>
          </li>
        </ul>

      </div>
    </div>

    <div class="w-full mt-4 px-3 lg:hidden">
      <div class="bg-white rounded-xl border border-solid border-gray-100 shadow-sm overflow-hidden">
        <button type="button" class="w-full flex items-center justify-between p-3 bg-transparent border-0 text-right"
          (click)="toggleScoreAccordion()">
          <div class="flex items-center gap-3">
            <div class="score-badge">
              {{modalData?.labelHotelReview.avgRate}}
            </div>
            <div>
              <p class="text-base font-bold text-gray-800 m-0">{{modalData?.labelHotelReview.avgRateTitle}}</p>
              <p class="text-xs text-gray-500 mt-1 m-0">بر اساس {{modalData?.labelHotelReview.totalReview}} نظر تأیید شده</p>
            </div>
          </div>
          <span class="accordion-chevron" [class.is-open]="isScoreAccordionOpen" aria-hidden="true"></span>
        </button>

        <div class="score-accordion-body" [class.is-open]="isScoreAccordionOpen">
          <div class="px-3 pb-3">
            <div class="grid grid-cols-3 gap-2 py-3 border-t border-solid border-gray-100">
              <div class="text-center">
                <p class="text-lg font-bold text-gray-800 m-0">{{modalData?.labelHotelReview.facilitiesReview}}</p>
                <p class="text-[11px] text-gray-500 mt-1 m-0 leading-4"
                  *ngIf="accommodation() != 'ecolodge'">از نظر امکانات هتل</p>
                <p class="text-[11px] text-gray-500 mt-1 m-0 leading-4"
                  *ngIf="accommodation() == 'ecolodge'">از نظر امکانات اقامتگاه</p>
              </div>
              <div class="text-center">
                <p class="text-lg font-bold text-gray-800 m-0">{{modalData?.labelHotelReview.cleanlinessReview}}</p>
                <p class="text-[11px] text-gray-500 mt-1 m-0 leading-4"
                  *ngIf="accommodation() != 'ecolodge'">پاکیزگی هتل و اتاق‌ها</p>
                <p class="text-[11px] text-gray-500 mt-1 m-0 leading-4"
                  *ngIf="accommodation() == 'ecolodge'">پاکیزگی اقامتگاه و اتاق‌ها</p>
              </div>
              <div class="text-center">
                <p class="text-lg font-bold text-gray-800 m-0">{{modalData?.labelHotelReview.locationReview}}</p>
                <p class="text-[11px] text-gray-500 mt-1 m-0 leading-4">از نظر موقعیت مکانی</p>
              </div>
            </div>

            <div class="mobile-charts-scroll scrollbar-hide mt-3">
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.locationReview)">
                  <span>{{modalData?.labelHotelReview.locationReview}}</span>
                </div>
                <p>موقعیت و دسترسی</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.facilitiesReview)">
                  <span>{{modalData?.labelHotelReview.facilitiesReview}}</span>
                </div>
                <p>امکانات</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.cleanlinessReview)">
                  <span>{{modalData?.labelHotelReview.cleanlinessReview}}</span>
                </div>
                <p *ngIf="accommodation() != 'ecolodge'">پاکیزگی هتل و اتاق‌ها</p>
                <p *ngIf="accommodation() == 'ecolodge'">پاکیزگی اقامتگاه و اتاق‌ها</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.valueForMoneyReview)">
                  <span>{{modalData?.labelHotelReview.valueForMoneyReview}}</span>
                </div>
                <p *ngIf="accommodation() != 'ecolodge'">ارزش هتل نسبت به قیمت</p>
                <p *ngIf="accommodation() == 'ecolodge'">ارزش اقامتگاه نسبت به قیمت</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.comfortReview)">
                  <span>{{modalData?.labelHotelReview.comfortReview}}</span>
                </div>
                <p>آرامش و راحتی</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.staffReview)">
                  <span>{{modalData?.labelHotelReview.staffReview}}</span>
                </div>
                <p>عملکرد کارکنان</p>
              </div>
              <div class="chart-card" *ngIf="modalData?.labelHotelReview.foodReview != 0">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.foodReview)">
                  <span>{{modalData?.labelHotelReview.foodReview}}</span>
                </div>
                <p>کیفیت غذا</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.businessReview)">
                  <span>{{modalData?.labelHotelReview.businessReview}}</span>
                </div>
                <p>برای کسب و کارها</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.friendsReview)">
                  <span>{{modalData?.labelHotelReview.friendsReview}}</span>
                </div>
                <p>برای دوستان</p>
              </div>
              <div class="chart-card">
                <div class="circular-score"
                  [style.--progress]="getCircleProgress(modalData?.labelHotelReview.couplesReview)">
                  <span>{{modalData?.labelHotelReview.couplesReview}}</span>
                </div>
                <p>برای خانواده‌ها</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mt-5 px-3 lg:hidden mobile-filters" *ngIf="accommodation() != 'ecolodge'">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-bold m-0">فیلتر نظرات</h3>
        <button *ngIf="showRemoveBtn" type="button" (click)="removeFilters()"
          class="text-red-500 text-sm bg-transparent border-0 p-0">حذف فیلتر</button>
      </div>

      <div class="grid grid-cols-2 gap-3 mobile-filter-selects mb-4">
        <mat-form-field class="w-full mobile-select-field" appearance="fill">
          <mat-select [(ngModel)]="selectedType" (ngModelChange)="selectedTypes($event)">
            <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.travelTypes" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full mobile-select-field" appearance="fill">
          <mat-select [(ngModel)]="selectedOrder" (ngModelChange)="selectedTypes($event)">
            <mat-option class="text-[12px]" *ngFor="let item of listRoomsFilters?.sortTypes" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ul class="mobile-chips-wrap mt-4">
        <li class="filter-chip cursor-pointer {{item.selected ? 'is-active' : ''}}"
          (click)="selectedLabels(item.name,'desk')"
          *ngFor="let item of listRoomsFilters?.voteFilterLabels">
          <span>{{item.name}} ({{item.count}})</span>
          <i *ngIf="item.selected" class="ico-Close chip-close"></i>
        </li>
      </ul>

      <h4 class="text-sm font-bold mt-5 mb-3">امتیاز کاربران</h4>
      <ul class="mobile-chips-wrap">
        <li class="filter-chip filter-chip--score cursor-pointer {{item.selected ? 'is-active' : ''}}"
          (click)="toggleGuestScore(item)"
          *ngFor="let item of guestScore">
          <span class="chip-text">
            <span class="chip-line">{{item.score}}</span>
            <span class="chip-line chip-line--muted">({{item.label}})</span>
          </span>
          <i *ngIf="item.selected" class="ico-Close chip-close"></i>
        </li>
      </ul>

      <h4 class="text-sm font-bold mt-5 mb-3">تاریخ نظرات</h4>
      <ul class="mobile-chips-wrap">
        <li class="filter-chip filter-chip--season cursor-pointer {{item.selected ? 'is-active' : ''}}"
          (click)="toggleHistoryComment(item)"
          *ngFor="let item of historyComments">
          <span class="chip-text">
            <span class="chip-line">{{item.line1}}</span>
            <span class="chip-line chip-line--muted">{{item.line2}}</span>
          </span>
          <i *ngIf="item.selected" class="ico-Close chip-close"></i>
        </li>
      </ul>
    </div>

    <!-- ===================== REVIEW LIST ===================== -->
    <div class="w-full p-3">
      <!-- Mobile loading skeletons -->
      <div class="lg:hidden space-y-3" *ngIf="loadingData">
        <div class="review-skeleton-card" *ngFor="let item of [0,1]">
          <div class="flex items-start justify-between gap-3">
            <div class="flex items-center gap-2">
              <iho-skeleton type="circle" height="2rem" width="2rem" />
              <div class="flex flex-col gap-2">
                <iho-skeleton height="12px" width="90px" />
                <iho-skeleton height="10px" width="48px" />
              </div>
            </div>
            <iho-skeleton height="10px" width="70px" />
          </div>
          <div class="mt-4 flex flex-col gap-2">
            <iho-skeleton height="12px" width="100%" />
            <iho-skeleton height="12px" width="95%" />
            <iho-skeleton height="12px" width="88%" />
            <iho-skeleton height="12px" width="55%" />
          </div>
          <div class="mt-4 flex flex-wrap gap-2">
            <iho-skeleton height="28px" width="72px" class="rounded-lg" />
            <iho-skeleton height="28px" width="88px" class="rounded-lg" />
            <iho-skeleton height="28px" width="64px" class="rounded-lg" />
            <iho-skeleton height="28px" width="76px" class="rounded-lg" />
          </div>
        </div>
      </div>

      <!-- Desktop loading -->
      <div class="w-full h-[50vh] hidden lg:flex justify-center items-center" *ngIf="loadingData">
        <iho-loading></iho-loading>
      </div>

      <ng-container *ngIf="!loadingData">
        <div class="w-full p-3 px-3 pt-0 border-bottom bg-white rounded-lg mb-3 hidden lg:block"
          *ngFor="let item of listVoteAll">
          <div class="w-full p-3">
            <div class="flex items-center">
              <div class="w-[25%]">
                <div style="display: flex; align-items: center; gap: 5px;">
                  <div class="text-sm "
                    style="border: 2px solid #0a6ada;
                    border-radius: 12px 12px 2px 12px;
                    background-color: #0a6ada; color: white; padding: 5px 10px; width: fit-content; display: flex; align-items: center; gap: 5px;">
                    <span class="text-sm text-white font-bold">{{item.rate}}</span>
                  </div>
                  <span class="text-lg mr-2 text-blue-500">{{item.rateTitle}}</span>
                </div>
                <p class="text-sm text-black-200 mt-3" *ngIf="accommodation() != 'ecolodge'">تاریخ درج نظر :
                  {{item.addDatePersian}}</p>
                <p class="text-sm text-black-200 mt-3" *ngIf="accommodation() != 'ecolodge'">
                  <span>تاریخ ورود:</span>
                  <span class="mr-2">
                    {{item.arrivalDatePersian}}
                  </span>
                  <span class="mx-2">|</span>
                  <span class="">{{item.duration}} شب اقامت</span>
                </p>
              </div>

              <div class="w-[75%] ">
                <div class="flex items-center mb-2">
                  <img src="https://www.iranhotelonline.com/content/assets/images/avatar.svg" class="mx-2">
                  <p class="text-sm text-black-200 mt-3"> {{item.guestName}}</p>
                </div>
                <div style="background-color: #f9fafb;
              border-radius: 30px 5px; padding:35px;">
                  <div class="w-full mt-4">
                    <h4 class="text-sm font-bold">{{item.title}}</h4>
                    <p class="text-sm text-black-300 mt-3">
                      {{item.description}}
                    </p>

                  </div>
                  <div class="w-full mt-4 text-sm text-black-200" *ngIf="accommodation() == 'ecolodge'">
                    <span>{{item.addDatePersian}}</span>
                  </div>

                </div>
              </div>
            </div>
            <!-- HotelAnswer -->
            <div class="w-full mt-4 bg-metal-50 p-3 rounded-lg" *ngIf="item.hotelAnswer">
              <h4 class="text-sm font-bold" *ngIf="accommodation() == 'ecolodge';else nameCommentHost">”پاسخ میزبان"
              </h4>
              <ng-template #nameCommentHost>
                <h4 class="text-sm font-bold">”پاسخ هتل“</h4>
              </ng-template>
              <p class="text-sm text-black-300 mt-3">
                {{item?.hotelAnswer}}
              </p>
              <p class="text-sm text-black-200 mt-3">
                {{item?.answerDatePersian}}
              </p>
            </div>
          </div>

        </div>

        <div class="lg:hidden space-y-3 mt-2 mb-5">
          <div class="bg-white rounded-xl shadow-sm border border-solid border-gray-100 p-4"
            *ngFor="let item of listVoteAll">
            <div class="flex items-start justify-between gap-2">
              <div class="flex items-center gap-2 min-w-0">
                <img src="https://www.iranhotelonline.com/content/assets/images/avatar.svg" class="w-8 h-8" alt="">
                <div class="min-w-0">
                  <p class="text-sm font-medium text-gray-800 m-0 truncate">{{item.guestName}}</p>
                  <p class="text-sm text-blue-500 font-bold m-0 mt-0.5">{{item.rate}}</p>
                </div>
              </div>
              <p class="text-xs text-gray-500 whitespace-nowrap m-0" *ngIf="accommodation() != 'ecolodge'">
                تاریخ ورود {{item.arrivalDatePersian}}
              </p>
            </div>

            <h4 class="text-sm font-bold mt-3 mb-2">«{{item.title}}»</h4>
            <p class="text-sm text-gray-600 leading-6 m-0">{{item.description}}</p>

            <div class="flex flex-wrap gap-2 mt-3" *ngIf="accommodation() != 'ecolodge'">
              <span class="meta-badge" *ngIf="item.roomName">{{item.roomName}}</span>
              <span class="meta-badge" *ngIf="item.travelTypeTitle">{{item.travelTypeTitle}}</span>
              <span class="meta-badge" *ngIf="item.cityName || modalData?.cityTitle">{{item.cityName || modalData?.cityTitle}}</span>
              <span class="meta-badge" *ngIf="item.duration">{{item.duration}} شب اقامت</span>
              <span class="meta-badge" *ngIf="item.addDatePersian">{{item.addDatePersian}}</span>
            </div>

            <div class="w-full mt-3 text-sm text-black-200" *ngIf="accommodation() == 'ecolodge'">
              <span>{{item.addDatePersian}}</span>
            </div>

            <div class="w-full mt-4 bg-metal-50 p-3 rounded-lg" *ngIf="item.hotelAnswer">
              <h4 class="text-sm font-bold" *ngIf="accommodation() == 'ecolodge';else nameCommentHostMobile">”پاسخ میزبان"</h4>
              <ng-template #nameCommentHostMobile>
                <h4 class="text-sm font-bold">”پاسخ هتل“</h4>
              </ng-template>
              <p class="text-sm text-black-300 mt-3">
                {{item?.hotelAnswer}}
              </p>
              <p class="text-sm text-black-200 mt-3">
                {{item?.answerDatePersian}}
              </p>
            </div>
          </div>
        </div>

        <div class="text-center text-sm text-gray-500" *ngIf="listVoteAll.length === 0">
          نظری وجود ندارد
        </div>

        <iho-pagination class="mt-5" *ngIf="listVoteAll.length > 0" [count]="modalData.vote.count" (paginate)="onPaginate($event)"
          [currentPage]="queryParams['page'] ? (+queryParams['page']) : 1" />
      </ng-container>
    </div>

  </ng-container>
  <ng-template #noData>
    <!-- Desktop skeleton -->
    <div class="hidden lg:block">
      <div class="flex justify-between mt-10">
        <div>
          <iho-skeleton *ngFor="let item of [0,1,2]" height="32px" width="100px"
            class="ml-2 overflow-hidden float-right" />
        </div>
        <iho-skeleton height="32px" width="150px" />
      </div>
      <div class="w-full  mt-10 shadow-md rounded-md p-3">
        <iho-skeleton height="32px" width="300px" />
        <div class="mt-5">
          <iho-skeleton height="20px" width="300px" />
        </div>
      </div>

      <div class="w-full flex gap-5 mt-10 shadow-md rounded-md p-3">
        <iho-skeleton height="200px" width="400px" />
        <iho-skeleton height="200px" width="600px" />
      </div>
      <div class="w-full flex gap-5 mt-10  p-3">
        <iho-skeleton height="30px" width="100px" />
        <iho-skeleton height="30px" width="200px" />
        <iho-skeleton height="30px" width="200px" />
      </div>
      <div class="w-full flex gap-5 mt-10  p-3">
        <iho-skeleton height="42px" width="100px" class="rounded-xl" *ngFor="let item of  [].constructor(10)" />
      </div>
    </div>

    <!-- Mobile skeleton -->
    <div class="lg:hidden px-3 mt-4 space-y-4">
      <iho-skeleton height="28px" width="85%" />
      <div class="flex items-center gap-2">
        <iho-skeleton type="circle" height="2rem" width="2rem" />
        <div class="flex flex-col gap-2 flex-1">
          <iho-skeleton height="12px" width="60%" />
          <iho-skeleton height="10px" width="80%" />
        </div>
      </div>
      <iho-skeleton height="44px" width="100%" class="rounded-lg" />

      <div class="review-skeleton-card">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <iho-skeleton height="40px" width="40px" class="rounded-lg" />
            <div class="flex flex-col gap-2">
              <iho-skeleton height="14px" width="48px" />
              <iho-skeleton height="10px" width="120px" />
            </div>
          </div>
          <iho-skeleton height="12px" width="12px" />
        </div>
      </div>

      <div class="flex flex-wrap gap-2">
        <iho-skeleton height="36px" width="110px" class="rounded-xl" *ngFor="let item of [0,1,2,3]" />
      </div>

      <div class="review-skeleton-card" *ngFor="let item of [0,1]">
        <div class="flex items-start justify-between gap-3">
          <div class="flex items-center gap-2">
            <iho-skeleton type="circle" height="2rem" width="2rem" />
            <div class="flex flex-col gap-2">
              <iho-skeleton height="12px" width="90px" />
              <iho-skeleton height="10px" width="48px" />
            </div>
          </div>
          <iho-skeleton height="10px" width="70px" />
        </div>
        <div class="mt-4 flex flex-col gap-2">
          <iho-skeleton height="12px" width="100%" />
          <iho-skeleton height="12px" width="95%" />
          <iho-skeleton height="12px" width="88%" />
          <iho-skeleton height="12px" width="55%" />
        </div>
        <div class="mt-4 flex flex-wrap gap-2">
          <iho-skeleton height="28px" width="72px" class="rounded-lg" />
          <iho-skeleton height="28px" width="88px" class="rounded-lg" />
          <iho-skeleton height="28px" width="64px" class="rounded-lg" />
          <iho-skeleton height="28px" width="76px" class="rounded-lg" />
        </div>
      </div>
    </div>
  </ng-template>
</div>
